import {Text} from "@mantine/core";
import {Link} from "react-router-dom";
import classes from "./LinkRow.module.css";
import {ExperimentalLink} from "../ExperimentalLink";
type LinkRowProps = {
    name: string;
    description?: string;
    rightSection?: React.ReactNode;
    onClick?: React.MouseEventHandler<HTMLAnchorElement>;
} & (
    | {href: string; download?: string; to?: never}
    | {to: string; href?: never; download?: never}
);

export function LinkRow({
    href,
    to,
    download,
    name,
    description,
    rightSection,
    onClick,
}: LinkRowProps) {
    const linkContent = (
        <>
            <Text className={classes.name}>{name}</Text>
            {description && (
                <Text className={classes.description}>{description}</Text>
            )}
        </>
    );

    return (
        <div className={classes.row}>
            {to ? (
                <Link to={to} className={classes.link} onClick={onClick}>
                    {linkContent}
                </Link>
            ) : href ? (
                <ExperimentalLink
                    href={href}
                    download={download}
                    className={classes.link}
                    onClick={onClick}
                >
                    {linkContent}
                </ExperimentalLink>
            ) : null}
            {rightSection && (
                <div className={classes.rightSection}>{rightSection}</div>
            )}
        </div>
    );
}
